import { Container } from '@/components/Container'
import './styles.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'

interface PrimaryNavigationItem {
	name: string
	url: string
	icon: string
	primaryNavChildren: PrimaryNavigationItem[]
}

interface SecondaryNavigationItem {
	name: string
	url: string
	icon: string
}

interface SocialNavigationItem {
	name: string
	url: string
	icon: string
}

interface Footer {
	id: number
	title: string
	primaryLogo: string
	secondaryLogo: string
	footerCopyrightTitle: string
	primaryNavigation: PrimaryNavigationItem[]
	secondaryNavigation: SecondaryNavigationItem[]
	socialNavigation: SocialNavigationItem[]
}

interface Props {
	footer: Footer
}

export default function Footer(props: Props) {
	console.log('footer data', props.footer)

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth', // Optional: smooth scrolling animation
		})
	}

	return (
		<div className='mt-14'>
			<footer className="relative z-20 w-full py-8 mx-auto font-semibold bg-surface-120">
				<div className="container px-8 mx-auto">
					<div className="flex flex-col items-start justify-between mb-8 lg:flex-row">
						<div className="flex items-center w-full lg:mt-0 lg:justify-between justify-center">
							<a href="/" className="flex items-center">
								<img
									src={props.footer.primaryLogo}
									alt="MAVS-logo"
									className="lg:block hidden w-[296.88px] h-12 relative"
								/>
								<svg
									width="49"
									height="48"
									className="lg:hidden block"
									viewBox="0 0 49 48"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clipPath="url(#clip0_9825_369)">
										<path
											d="M26.326 19.1515L16.4191 19.3452C17.0928 20.2126 18.0284 20.6545 19.0377 20.8318C21.5662 21.1155 24.2557 20.619 26.8579 20.5126C27.0516 20.3544 27.0843 20.2562 27.1716 19.948C27.2944 19.6425 27.3708 19.2634 27.2453 19.1515H26.326ZM25.2459 17.0458C26.0778 17.1167 26.8389 17.6295 27.6517 17.8422C27.8999 18.055 28.2518 18.0714 28.4482 18.3196C28.2191 19.3452 28.3773 20.8481 27.1553 21.1509C26.5361 21.2027 26.086 21.2737 25.2104 21.3091C23.7429 21.4073 22.3191 21.4591 21.8608 21.5164C20.7998 21.6501 19.9024 21.6446 18.9286 21.6283C17.1583 21.3637 15.639 19.9835 14.7879 18.426C14.7716 18.3196 14.8425 18.2323 14.9298 18.1968C17.0519 17.7359 19.3186 17.594 21.4244 17.0812C22.6464 16.9039 24.0266 16.7266 25.2459 17.0458ZM20.3988 15.9656C17.8511 16.5329 15.3198 17.1685 12.7913 17.7877C13.8169 19.5389 15.0198 21.2546 16.2582 22.9021L24.1303 22.7793L28.4291 22.6921C28.5164 22.392 29.3483 20.0217 29.5965 19.1188C29.7029 18.7124 29.943 18.0086 29.6675 17.7822C29.2119 17.5204 28.6582 17.2203 28.2518 17.0076C27.5453 16.653 27.1716 16.5166 26.4815 16.1265C24.624 15.2591 22.3054 15.4528 20.3961 15.9656H20.3988ZM32.2533 18.5487C31.6178 18.1341 30.8649 18.996 30.2375 19.5034C30.0903 19.9671 29.8666 20.529 29.7957 21.0254C29.7602 21.1318 29.7247 21.3446 29.8311 21.4155C29.9539 21.38 30.1584 21.3391 30.3576 21.14C31.2604 20.5045 31.9014 19.6643 32.7497 18.9906L32.6979 18.8678C32.5397 18.7615 32.3433 18.6905 32.256 18.5487H32.2533ZM16.8064 26.3172C16.6837 26.5654 16.5937 26.8654 16.6482 27.1491L18.2412 28.8648C18.3476 29.0776 18.5249 29.2194 18.7185 29.3776C18.8958 29.3067 19.1795 29.2712 19.1959 29.023C18.4703 28.0847 17.9739 26.9691 17.2156 25.998C17.0574 26.0335 16.8964 26.1562 16.8092 26.3172H16.8064ZM33.8981 19.6643C33.6717 19.6152 33.4071 19.6807 32.9298 20.008C31.3941 20.9873 29.0865 22.9976 29.0537 23.2758C28.7673 23.8868 28.74 24.7624 28.5191 25.3434C28.5546 25.2888 28.6609 25.1142 28.7155 25.1142C30.6085 23.5049 32.3951 21.841 34.2882 20.1962C34.4818 19.8607 34.16 19.7925 33.8981 19.6643ZM27.0871 23.5404L16.7355 23.734C17.0901 24.3532 19.2532 27.8201 19.5668 27.7846C20.647 27.6783 21.629 27.6346 22.66 27.5337C23.5574 27.4437 26.5743 27.4901 27.4417 26.1589C27.7253 25.4334 27.9899 24.4841 28.0772 23.5404H27.0871ZM7.25408 32.8827L5.69657 32.0507C5.62565 32.4217 5.76749 32.8118 5.94479 33.1282C9.07617 34.7566 12.1094 36.6142 15.2516 38.2235C16.3127 38.7663 16.4246 38.6899 18.934 38.4799C19.9296 38.3981 20.4042 38.3135 21.3207 38.2235C21.3998 37.9835 21.5335 37.6561 21.5499 37.3916C21.5499 37.3916 17.9057 37.7107 16.2254 37.9398L14.1906 36.7887L7.25408 32.8772V32.8827ZM5.21922 30.1059C5.11284 30.3541 5.25468 30.6542 5.34197 30.9024L16.1354 36.8651L16.5773 37.0424C18.3639 36.8296 20.1506 36.6005 21.9208 36.3878C22.2045 36.175 22.24 35.7522 22.3464 35.4331L22.2754 35.3622C20.3306 35.5913 18.4185 35.9104 16.49 36.1941C15.5517 35.7167 8.06693 31.5407 5.21922 30.1086V30.1059ZM6.29939 28.7421C6.07026 28.9003 5.77022 29.0257 5.62838 29.2549L16.4573 35.2339C16.9892 35.3185 17.9302 35.0976 18.6858 34.9503C18.9177 34.9039 21.3917 34.5084 22.5946 34.3311C22.9846 34.1374 23.0365 33.641 23.1783 33.2509L16.9674 34.1702L13.746 32.5254C11.2692 31.2515 8.79249 29.9422 6.29666 28.7393L6.29939 28.7421ZM34.4136 9.52553V12.2696L39.1898 14.9236C39.2771 14.6399 39.4735 14.3917 39.438 14.0562C37.8996 12.5342 36.1484 10.9603 34.5364 9.52553H34.4136ZM31.9887 40.4193C31.2986 41.0739 30.5921 41.7995 29.8829 42.3996C29.8475 42.6996 29.9348 43.0897 30.183 43.3543C30.2539 43.3352 30.3412 43.3734 30.3958 43.3188C31.2632 42.5578 32.1824 41.9741 33.0143 41.1612C33.0143 41.0548 33.0143 40.9484 32.908 40.8966C32.6434 40.632 32.3951 40.4356 31.9887 40.4193ZM37.2804 23.2021L28.5928 32.4544L24.0648 33.1254C23.8875 33.6737 22.8619 36.4696 22.5618 37.337C22.2973 38.0353 22.1554 38.5754 21.8363 39.1427L15.8545 39.6555L6.33485 34.2765C6.26393 34.2574 6.2121 34.2765 6.17664 34.3284L6.46032 35.8313L16.6155 42.9969L29.0346 43.1224L28.2382 40.7684C28.3091 40.4493 28.5573 40.2556 28.8055 40.0429C30.8404 37.8853 32.927 35.8313 34.9619 33.6901C35.4583 31.9198 35.7938 30.0814 36.2548 28.2947C36.5385 28.3493 36.784 28.472 37.0513 28.5784C36.8031 30.0459 36.3066 31.4097 36.0966 32.8963C35.8839 33.5155 35.9548 34.2929 35.2838 34.683C33.2298 36.7178 31.285 38.84 29.2338 40.8584L29.1983 41.0521C29.2692 41.2103 29.321 41.4422 29.482 41.494C30.333 40.9103 31.0559 39.9556 31.836 39.3364C32.6488 39.3364 33.2325 40.062 33.9417 40.3811C36.083 38.8045 38.0633 37.2142 40.1172 35.4794C40.5073 33.9929 41.0555 32.5417 41.462 31.0906C41.7811 29.7622 42.1875 28.472 42.5421 27.1436C40.8264 25.7634 39.0043 24.5769 37.2886 23.1994L37.2804 23.2021ZM6.50942 14.3399L6.10299 14.2171C5.92569 14.3944 5.94479 14.6427 5.71293 14.7845C5.62565 15.2809 5.28742 15.6683 5.2165 16.1647C4.79098 16.713 4.8619 17.474 4.54549 18.0741C3.96176 19.8253 3.87175 21.6665 3.5908 23.4885C3.64262 23.895 3.44896 24.3559 3.749 24.6915C8.22513 27.2937 12.6167 29.8713 17.0737 32.4899L17.6547 32.689C20.6797 32.0344 23.7948 31.5734 26.8007 30.8669C28.9583 30.7087 30.1257 28.7093 31.3477 27.1164C32.9052 25.1006 34.2854 23.1176 35.772 21.0664C35.6656 20.8372 35.4883 20.7118 35.2756 20.6245C32.6215 22.4466 30.4503 24.8306 28.009 26.92C27.7472 27.19 27.4389 27.2418 27.2071 27.4382C26.4297 27.8283 25.6196 27.9156 24.624 28.0056C23.1783 28.1338 19.9133 28.4475 19.9133 28.4475C19.9133 28.4475 20.2188 28.9603 20.2351 29.2603C19.9514 29.7377 19.5587 29.8631 19.0322 30.215C18.4076 30.5914 18.2003 30.9924 17.652 30.8151C14.0951 27.9483 10.5027 25.1006 6.96494 22.2174C7.08769 22.0592 7.1777 21.721 7.46138 21.7919C7.58685 21.9338 7.81598 21.8983 7.85144 22.1111C11.1247 24.7133 14.3106 27.3673 17.6002 29.8959C17.742 29.9832 17.9902 30.0186 18.0775 29.825C17.281 28.9221 16.4491 28.1802 15.7235 27.2773C15.7945 26.5354 16.2718 25.9325 16.5364 25.2779C15.3689 23.0848 13.7951 21.05 12.5021 18.9088L11.7411 18.1123L6.50396 14.3426L6.50942 14.3399ZM29.8829 3.95287C27.919 4.05925 25.9905 4.25291 24.0266 4.41385C21.4244 4.64297 18.7185 4.59115 16.4191 5.54584C13.5005 7.28064 10.7919 9.2964 8.0151 11.2249C7.82143 11.4022 7.82143 11.7568 7.92509 11.9859C8.7734 11.5086 9.60534 10.9412 10.4727 10.4639C12.2594 9.38369 14.0651 8.34171 15.8872 7.29701C19.2504 5.08486 23.7784 5.88134 27.8126 5.3849C27.9899 5.54311 27.8672 5.82679 27.9545 6.02318C27.3353 6.18139 26.6288 6.11047 26.0096 6.21685C23.1428 6.60691 19.6923 5.96863 17.2156 7.49068C16.3236 7.848 9.4826 11.9313 7.89235 13.0279C7.99873 13.2761 8.24695 13.6116 8.52791 13.6116C10.0309 12.8342 11.5065 11.9968 12.9877 11.1512C14.1469 10.4911 16.19 9.29367 17.9248 8.56811C18.7567 8.33899 19.605 8.09077 20.4724 7.87801C22.9846 7.75526 25.5323 7.59433 28.0445 7.52341C28.0281 7.71707 28.0963 7.94893 27.9736 8.09077L19.9951 8.56811L19.9242 8.63903C19.5341 8.63903 19.2532 8.88725 18.8795 8.92271C17.6929 9.29367 16.6237 9.9265 15.5353 10.5157C13.3177 11.7159 11.0756 12.8697 8.93706 14.179C9.14982 14.4981 9.4144 14.7627 9.73354 14.9754C12.4394 13.7889 15.148 12.6405 17.8184 11.4185C18.6858 10.9221 19.5887 10.5702 20.5597 10.3575C23.1074 10.1447 25.5487 10.0574 28.1154 9.91559C28.2218 10.1283 28.2927 10.4284 28.17 10.6412L20.8107 11.0667L19.6078 11.3858L10.3364 15.5619C10.6009 15.881 10.8683 16.1974 11.1328 16.4811C14.2997 15.6846 17.3956 14.7463 20.5625 13.9689L27.5699 13.8625L43.8814 24.2141L43.2104 21.631L41.0337 12.9433L29.9893 4.1138L29.8829 3.9556V3.95287ZM34.1081 4.32111L43.1504 11.0094L47.0783 24.6314C47.0783 24.7896 46.901 24.8797 46.8846 25.0215L42.3539 37.7789L30.6412 45.8119H16.5582L5.0392 36.9469C3.64262 32.5608 2.49154 28.0465 0.953125 23.7122L1.09496 23.1994L5.552 10.3357L17.3874 2.05713H31.1186L34.1081 4.32111Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_9825_369">
											<rect
												width="48"
												height="48"
												fill="white"
												transform="translate(0.160156)"
											/>
										</clipPath>
									</defs>
								</svg>

								<div className="w-12 h-[0px] rotate-90 border border-white border-opacity-20"></div>
								<img
									src={props.footer.secondaryLogo}
									alt="MAVS-logo"
									className="w-[99.68px] h-7"
								/>
							</a>
							<div className="items-center lg:flex hidden">
								<span className="text-white text-sm mr-4">
									Follow us
								</span>
								<a
									className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
									href="https://www.facebook.com/VinniesAU"
								>
									<svg
										width="18"
										height="32"
										viewBox="0 0 18 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M16.4375 18L17.3125 12.25H11.75V8.5C11.75 6.875 12.5 5.375 15 5.375H17.5625V0.4375C17.5625 0.4375 15.25 0 13.0625 0C8.5 0 5.5 2.8125 5.5 7.8125V12.25H0.375V18H5.5V32H11.75V18H16.4375Z"
											fill="white"
										></path>
									</svg>
								</a>
								<a
									className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
									href="https://www.youtube.com/user/VinniesAU"
								>
									<svg
										width="36"
										height="24"
										viewBox="0 0 36 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M34.3125 3.8125C33.9375 2.3125 32.75 1.125 31.3125 0.75C28.625 0 18 0 18 0C18 0 7.3125 0 4.625 0.75C3.1875 1.125 2 2.3125 1.625 3.8125C0.875 6.4375 0.875 12.0625 0.875 12.0625C0.875 12.0625 0.875 17.625 1.625 20.3125C2 21.8125 3.1875 22.9375 4.625 23.3125C7.3125 24 18 24 18 24C18 24 28.625 24 31.3125 23.3125C32.75 22.9375 33.9375 21.8125 34.3125 20.3125C35.0625 17.625 35.0625 12.0625 35.0625 12.0625C35.0625 12.0625 35.0625 6.4375 34.3125 3.8125ZM14.5 17.125V7L23.375 12.0625L14.5 17.125Z"
											fill="white"
										></path>
									</svg>
								</a>
								<a
									className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
									href="https://www.instagram.com/vinniesaus/"
								>
									<svg
										width="29"
										height="29"
										viewBox="0 0 29 29"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M15 6.8125C11 6.8125 7.8125 10.0625 7.8125 14C7.8125 18 11 21.1875 15 21.1875C18.9375 21.1875 22.1875 18 22.1875 14C22.1875 10.0625 18.9375 6.8125 15 6.8125ZM15 18.6875C12.4375 18.6875 10.3125 16.625 10.3125 14C10.3125 11.4375 12.375 9.375 15 9.375C17.5625 9.375 19.625 11.4375 19.625 14C19.625 16.625 17.5625 18.6875 15 18.6875ZM24.125 6.5625C24.125 7.5 23.375 8.25 22.4375 8.25C21.5 8.25 20.75 7.5 20.75 6.5625C20.75 5.625 21.5 4.875 22.4375 4.875C23.375 4.875 24.125 5.625 24.125 6.5625ZM28.875 8.25C28.75 6 28.25 4 26.625 2.375C25 0.75 23 0.25 20.75 0.125C18.4375 0 11.5 0 9.1875 0.125C6.9375 0.25 5 0.75 3.3125 2.375C1.6875 4 1.1875 6 1.0625 8.25C0.9375 10.5625 0.9375 17.5 1.0625 19.8125C1.1875 22.0625 1.6875 24 3.3125 25.6875C5 27.3125 6.9375 27.8125 9.1875 27.9375C11.5 28.0625 18.4375 28.0625 20.75 27.9375C23 27.8125 25 27.3125 26.625 25.6875C28.25 24 28.75 22.0625 28.875 19.8125C29 17.5 29 10.5625 28.875 8.25ZM25.875 22.25C25.4375 23.5 24.4375 24.4375 23.25 24.9375C21.375 25.6875 17 25.5 15 25.5C12.9375 25.5 8.5625 25.6875 6.75 24.9375C5.5 24.4375 4.5625 23.5 4.0625 22.25C3.3125 20.4375 3.5 16.0625 3.5 14C3.5 12 3.3125 7.625 4.0625 5.75C4.5625 4.5625 5.5 3.625 6.75 3.125C8.5625 2.375 12.9375 2.5625 15 2.5625C17 2.5625 21.375 2.375 23.25 3.125C24.4375 3.5625 25.375 4.5625 25.875 5.75C26.625 7.625 26.4375 12 26.4375 14C26.4375 16.0625 26.625 20.4375 25.875 22.25Z"
											fill="white"
										></path>
									</svg>
								</a>
								<a
									className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
									href="https://twitter.com/VinniesAust"
								>
									<svg
										width="32"
										height="26"
										viewBox="0 0 32 26"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M28.6875 6.5C28.6875 6.8125 28.6875 7.0625 28.6875 7.375C28.6875 16.0625 22.125 26 10.0625 26C6.3125 26 2.875 24.9375 0 23.0625C0.5 23.125 1 23.1875 1.5625 23.1875C4.625 23.1875 7.4375 22.125 9.6875 20.375C6.8125 20.3125 4.375 18.4375 3.5625 15.8125C4 15.875 4.375 15.9375 4.8125 15.9375C5.375 15.9375 6 15.8125 6.5 15.6875C3.5 15.0625 1.25 12.4375 1.25 9.25V9.1875C2.125 9.6875 3.1875 9.9375 4.25 10C2.4375 8.8125 1.3125 6.8125 1.3125 4.5625C1.3125 3.3125 1.625 2.1875 2.1875 1.25C5.4375 5.1875 10.3125 7.8125 15.75 8.125C15.625 7.625 15.5625 7.125 15.5625 6.625C15.5625 3 18.5 0.0625 22.125 0.0625C24 0.0625 25.6875 0.8125 26.9375 2.125C28.375 1.8125 29.8125 1.25 31.0625 0.5C30.5625 2.0625 29.5625 3.3125 28.1875 4.125C29.5 4 30.8125 3.625 31.9375 3.125C31.0625 4.4375 29.9375 5.5625 28.6875 6.5Z"
											fill="white"
										></path>
									</svg>
								</a>
								<a
									className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
									href="https://www.linkedin.com/company/vinnies-australia/"
								>
									<svg
										width="28"
										height="28"
										viewBox="0 0 28 28"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M26 0H1.9375C0.875 0 0 0.9375 0 2.0625V26C0 27.125 0.875 28 1.9375 28H26C27.0625 28 28 27.125 28 26V2.0625C28 0.9375 27.0625 0 26 0ZM8.4375 24H4.3125V10.6875H8.4375V24ZM6.375 8.8125C5 8.8125 3.9375 7.75 3.9375 6.4375C3.9375 5.125 5 4 6.375 4C7.6875 4 8.75 5.125 8.75 6.4375C8.75 7.75 7.6875 8.8125 6.375 8.8125ZM24 24H19.8125V17.5C19.8125 16 19.8125 14 17.6875 14C15.5 14 15.1875 15.6875 15.1875 17.4375V24H11.0625V10.6875H15V12.5H15.0625C15.625 11.4375 17 10.3125 19 10.3125C23.1875 10.3125 24 13.125 24 16.6875V24Z"
											fill="white"
										></path>
									</svg>
								</a>
							</div>
						</div>
					</div>
					<div className="w-full h-[0px] border border-white border-opacity-20"></div>
					<div className="my-8">
						<div className="flex flex-col justify-between xl:flex-row ">
							<ul className="w-full grid lg:grid-flow-col lg:grid-rows-3 lg:gap-3 md:grid-cols-3 grid-flow-row grid-cols-1 gap-4">
								{props.footer.primaryNavigation.map(
									(item, index) => {
										return (
											<li
												key={index}
												className="self-stretch text-white text-base font-bold leading-normal"
											>
												<a href={item.url} className='text-white'>
													{item.name}
												</a>
											</li>
										)
									},
								)}
							</ul>
						</div>
					</div>
					<div className="w-full h-[0px] border border-white border-opacity-20"></div>
					<div className="items-center justify-center mt-6 lg:hidden flex">
						<span className="text-white mr-4 text-sm">Follow us</span>
						<a
							className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
							href="https://www.facebook.com/VinniesAU"
						>
							<svg
								width="18"
								height="32"
								viewBox="0 0 18 32"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.4375 18L17.3125 12.25H11.75V8.5C11.75 6.875 12.5 5.375 15 5.375H17.5625V0.4375C17.5625 0.4375 15.25 0 13.0625 0C8.5 0 5.5 2.8125 5.5 7.8125V12.25H0.375V18H5.5V32H11.75V18H16.4375Z"
									fill="white"
								></path>
							</svg>
						</a>
						<a
							className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
							href="https://www.youtube.com/user/VinniesAU"
						>
							<svg
								width="36"
								height="24"
								viewBox="0 0 36 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M34.3125 3.8125C33.9375 2.3125 32.75 1.125 31.3125 0.75C28.625 0 18 0 18 0C18 0 7.3125 0 4.625 0.75C3.1875 1.125 2 2.3125 1.625 3.8125C0.875 6.4375 0.875 12.0625 0.875 12.0625C0.875 12.0625 0.875 17.625 1.625 20.3125C2 21.8125 3.1875 22.9375 4.625 23.3125C7.3125 24 18 24 18 24C18 24 28.625 24 31.3125 23.3125C32.75 22.9375 33.9375 21.8125 34.3125 20.3125C35.0625 17.625 35.0625 12.0625 35.0625 12.0625C35.0625 12.0625 35.0625 6.4375 34.3125 3.8125ZM14.5 17.125V7L23.375 12.0625L14.5 17.125Z"
									fill="white"
								></path>
							</svg>
						</a>
						<a
							className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
							href="https://www.instagram.com/vinniesaus/"
						>
							<svg
								width="29"
								height="29"
								viewBox="0 0 29 29"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M15 6.8125C11 6.8125 7.8125 10.0625 7.8125 14C7.8125 18 11 21.1875 15 21.1875C18.9375 21.1875 22.1875 18 22.1875 14C22.1875 10.0625 18.9375 6.8125 15 6.8125ZM15 18.6875C12.4375 18.6875 10.3125 16.625 10.3125 14C10.3125 11.4375 12.375 9.375 15 9.375C17.5625 9.375 19.625 11.4375 19.625 14C19.625 16.625 17.5625 18.6875 15 18.6875ZM24.125 6.5625C24.125 7.5 23.375 8.25 22.4375 8.25C21.5 8.25 20.75 7.5 20.75 6.5625C20.75 5.625 21.5 4.875 22.4375 4.875C23.375 4.875 24.125 5.625 24.125 6.5625ZM28.875 8.25C28.75 6 28.25 4 26.625 2.375C25 0.75 23 0.25 20.75 0.125C18.4375 0 11.5 0 9.1875 0.125C6.9375 0.25 5 0.75 3.3125 2.375C1.6875 4 1.1875 6 1.0625 8.25C0.9375 10.5625 0.9375 17.5 1.0625 19.8125C1.1875 22.0625 1.6875 24 3.3125 25.6875C5 27.3125 6.9375 27.8125 9.1875 27.9375C11.5 28.0625 18.4375 28.0625 20.75 27.9375C23 27.8125 25 27.3125 26.625 25.6875C28.25 24 28.75 22.0625 28.875 19.8125C29 17.5 29 10.5625 28.875 8.25ZM25.875 22.25C25.4375 23.5 24.4375 24.4375 23.25 24.9375C21.375 25.6875 17 25.5 15 25.5C12.9375 25.5 8.5625 25.6875 6.75 24.9375C5.5 24.4375 4.5625 23.5 4.0625 22.25C3.3125 20.4375 3.5 16.0625 3.5 14C3.5 12 3.3125 7.625 4.0625 5.75C4.5625 4.5625 5.5 3.625 6.75 3.125C8.5625 2.375 12.9375 2.5625 15 2.5625C17 2.5625 21.375 2.375 23.25 3.125C24.4375 3.5625 25.375 4.5625 25.875 5.75C26.625 7.625 26.4375 12 26.4375 14C26.4375 16.0625 26.625 20.4375 25.875 22.25Z"
									fill="white"
								></path>
							</svg>
						</a>
						<a
							className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
							href="https://twitter.com/VinniesAust"
						>
							<svg
								width="32"
								height="26"
								viewBox="0 0 32 26"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M28.6875 6.5C28.6875 6.8125 28.6875 7.0625 28.6875 7.375C28.6875 16.0625 22.125 26 10.0625 26C6.3125 26 2.875 24.9375 0 23.0625C0.5 23.125 1 23.1875 1.5625 23.1875C4.625 23.1875 7.4375 22.125 9.6875 20.375C6.8125 20.3125 4.375 18.4375 3.5625 15.8125C4 15.875 4.375 15.9375 4.8125 15.9375C5.375 15.9375 6 15.8125 6.5 15.6875C3.5 15.0625 1.25 12.4375 1.25 9.25V9.1875C2.125 9.6875 3.1875 9.9375 4.25 10C2.4375 8.8125 1.3125 6.8125 1.3125 4.5625C1.3125 3.3125 1.625 2.1875 2.1875 1.25C5.4375 5.1875 10.3125 7.8125 15.75 8.125C15.625 7.625 15.5625 7.125 15.5625 6.625C15.5625 3 18.5 0.0625 22.125 0.0625C24 0.0625 25.6875 0.8125 26.9375 2.125C28.375 1.8125 29.8125 1.25 31.0625 0.5C30.5625 2.0625 29.5625 3.3125 28.1875 4.125C29.5 4 30.8125 3.625 31.9375 3.125C31.0625 4.4375 29.9375 5.5625 28.6875 6.5Z"
									fill="white"
								></path>
							</svg>
						</a>
						<a
							className="transition-all hover:opacity-75 mr-5 xl:ml-5 xl:mr-0"
							href="https://www.linkedin.com/company/vinnies-australia/"
						>
							<svg
								width="28"
								height="28"
								viewBox="0 0 28 28"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M26 0H1.9375C0.875 0 0 0.9375 0 2.0625V26C0 27.125 0.875 28 1.9375 28H26C27.0625 28 28 27.125 28 26V2.0625C28 0.9375 27.0625 0 26 0ZM8.4375 24H4.3125V10.6875H8.4375V24ZM6.375 8.8125C5 8.8125 3.9375 7.75 3.9375 6.4375C3.9375 5.125 5 4 6.375 4C7.6875 4 8.75 5.125 8.75 6.4375C8.75 7.75 7.6875 8.8125 6.375 8.8125ZM24 24H19.8125V17.5C19.8125 16 19.8125 14 17.6875 14C15.5 14 15.1875 15.6875 15.1875 17.4375V24H11.0625V10.6875H15V12.5H15.0625C15.625 11.4375 17 10.3125 19 10.3125C23.1875 10.3125 24 13.125 24 16.6875V24Z"
									fill="white"
								></path>
							</svg>
						</a>
					</div>
					<div className="w-full lg:mt-8 mt-6 justify-between items-center md:gap-16 gap-4 flex flex-wrap">
						<div className="text-white text-sm font-normal leading-tight text-center md:w-auto w-full">
							© 2023 St Vincent de Paul Society NSW
						</div>
						<div className="justify-center items-start gap-6 flex md:w-auto w-full">
							{
								props.footer.secondaryNavigation
									.map((item, index) => {
										return (
											<a
												key={index}
												href={item.url}
												className='text-white text-sm font-normal leading-tight'
											>
												{item.name}
											</a>
										)
							}
							)}
						</div>
					</div>
				</div>
				<button
					onClick={scrollToTop}
					className="fixed bottom-5 right-0 cursor-pointer ml-auto block mr-4 w-12 h-12 p-3.5 bg-black bg-opacity-60 rounded-[48px] border border-black border-opacity-0 justify-center items-center gap-2"
				>
					<FontAwesomeIcon
						icon={faChevronUp}
						className="text-white"
					/>
				</button>
			</footer>
		</div>
	)
}
